import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/lib/store';
import { equipmentAdapter } from '@/entities/equipment/model/equipment.slice';

const baseSelectors = equipmentAdapter.getSelectors((state: RootState) => state.equipments);

const selectLoadEquipments = createSelector([baseSelectors.selectAll], (equipments) =>
	equipments.filter((equipment) => equipment.role === 'load'),
);

const equipmentSliceSelectors = {
	...baseSelectors,
	selectLoadEquipments,
};

export { equipmentSliceSelectors };
